import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import CardCSS from "../../../../../../library/Card/Card";
import BetPlacedChip from "../../../../../../library/Chips/BetChip";

import spadeCard from "../../../../../../assets/games/AB_Classic/spade.svg"
import heartCard from "../../../../../../assets/games/AB_Classic/heart.svg"
import diamondCard from "../../../../../../assets/games/AB_Classic/diamond.svg"
import clubCard from "../../../../../../assets/games/AB_Classic/club.svg"
import timerBack from "../../../../../../assets/games/AB_classic_Non_timer/Timer.svg"
import useSafeTimeout from "../../../../Utillitys/useSafeTimeout";
const AllCards = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"]


const AndarBaharCardContainer = forwardRef((props, ref) => {

    const [andarCards, setAndarCards] = useState([])
    const [jokerCard, setJokerCard] = useState("")
    const [baharCards, setBaharCards] = useState([])
    const [isDealt, setIsDealt] = useState(false)
    const [showAB_Bets, setShowAB_Bets] = useState(false)
    const [disableAB_Bets, setAB_Bets] = useState(false)
    const cardsDealingInterval = useRef()

    const currentIndex = useRef(0);
    const cardsData = useRef({ andar: [], bahar: [] });
    const { setSafeTimeout } = useSafeTimeout()

    useImperativeHandle(ref, () => ({
        setJokerCard,
        startDealingCards,
        setIsDealt,
        clearAllCards,
        setAB_Bets,
        isDealt,
        disableAB_Bets
    }))

    useEffect(() => {
        if (!props.isInitial) {
            if (andarCards.length || baharCards.length || jokerCard) {
                props.playTheSound("cardFallSound")
            }
        }
    }, [andarCards, baharCards, jokerCard])


    const startDealingCards = (res) => {
        setAndarCards([]);
        setBaharCards([]);
        setAB_Bets(true)
        cardsData.current = {
            andar: res.andharCards,
            bahar: res.baharCards
        };

        currentIndex.current = 0;
        dealNextAndarCard();
    };

    const dealNextAndarCard = () => {
        const { andar, bahar } = cardsData.current;
        const i = currentIndex.current;

        if (i < Math.max(andar.length, bahar.length)) {
            if (andar[i]) setAndarCards(prev => [...prev, andar[i]]);
        } else {
            props.setWinGlow()
        }
    };

    const dealNextBaharCard = () => {
        const { andar, bahar } = cardsData.current;
        const i = currentIndex.current;

        if (i < Math.max(andar.length, bahar.length)) {
            if (bahar[i]) setBaharCards(prev => [...prev, bahar[i]]);
            else props.setWinGlow()
        }
    };

    const clearAllCards = () => {
        setJokerCard("")
        setAndarCards([])
        setBaharCards([])
        setShowAB_Bets(false)
    }

    const setJokerCardFn = (card) => {
        setJokerCard(card)
        props.setInfoMsg(props.gameResult?.message)
    }

    return (<>
        <div id="ABC_NT_All_Cards" className={isDealt ? "moveTheElements" : ""}>
            {
                AllCards.map((ele, ind) => <div key={JSON.stringify(ele)} className={`ABC_NT_bet_All_Cards${(props.showWinAnimation && props.winResult?.rankCard === ind) ? " winAnimation" : ""}${disableAB_Bets ? " disabled" : ""}`} onClick={() => { props.placeBet("rankCards", ind) }}>
                    <div className="abc_nt_betCard_suits top_cards">
                        <div className="ABC_NT_BET_CARD_SUITS"><div className="clubCard"><div className="clubTale"></div></div></div>
                        <div className="ABC_NT_BET_CARD_SUITS betCardHeart"><div className="heartCard"></div></div>
                    </div>
                    <span className="ABT_bet_card_num">{ele}</span>
                    {props.cardsBet[ind] && <div className="betChipOnCard"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.cardsBet[ind]} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}
                    <div className="abc_nt_betCard_suits bottom_cards">
                        <div className="ABC_NT_BET_CARD_SUITS"><div className="diamondCard"></div></div>
                        <div className="ABC_NT_BET_CARD_SUITS betCardSpade"><div className="spadeCard"><div className="spadeTale"></div></div></div>
                    </div>
                </div>)
            }
        </div>
        <div id="ABC_suit_bets_container" className={isDealt ? "moveTheElements" : ""}>
            <div className={`ABC_suit_groups ${isDealt ? "moveTheElements" : ""}`}>
                <div className="ABC_NT_grouped_suits">
                    <div className={`ABC_NT_bets_suits ${(props.showWinAnimation && props.winResult?.suitBet === 1) ? "winAnimation" : ""}`} onClick={() => { props.placeBet("suits", "club") }} style={{ background: `url(${clubCard})` }} >{Boolean(props.suitBets.club) && <div className="ABC_NT_suit_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.suitBets.club} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}</div>
                    <div className={`ABC_NT_bets_suits ${(props.showWinAnimation && props.winResult?.suitBet === 3) ? "winAnimation" : ""}`} onClick={() => { props.placeBet("suits", "heart") }} style={{ background: `url(${heartCard})` }} >{Boolean(props.suitBets.heart) && <div className="ABC_NT_suit_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.suitBets.heart} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}</div>
                </div>
                <div className={`ABC_NT_cards_group ${(props.showWinAnimation && props.winResult?.sixSet === 0) ? "winAnimation" : ""}`} style={{ background: `url(${timerBack})` }} onClick={() => { props.placeBet("firstSixBet") }}>
                    <div>A - 6</div>
                    {Boolean(props.firstSixBet) && <div className="ABT_NT_first_last_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.firstSixBet} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}
                </div>
            </div>
            <div className={`ABC_suit_groups ${isDealt ? "moveTheElements" : ""}`}>
                <div className="ABC_NT_grouped_suits">
                    <div className={`ABC_NT_bets_suits ${(props.showWinAnimation && props.winResult?.suitBet === 2) ? "winAnimation" : ""}`} onClick={() => { props.placeBet("suits", "diamond") }} style={{ background: `url(${diamondCard})` }} >{Boolean(props.suitBets.diamond) && <div className="ABC_NT_suit_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.suitBets.diamond} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}</div>
                    <div className={`ABC_NT_bets_suits ${(props.showWinAnimation && props.winResult?.suitBet === 0) ? "winAnimation" : ""}`} onClick={() => { props.placeBet("suits", "spade") }} style={{ background: `url(${spadeCard})` }} >{Boolean(props.suitBets.spade) && <div className="ABC_NT_suit_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.suitBets.spade} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}</div>
                </div>
                <div className={`ABC_NT_cards_group ${(props.showWinAnimation && props.winResult?.sixSet === 1) ? "winAnimation" : ""}`} style={{ background: `url(${timerBack})` }} onClick={() => { props.placeBet("lastSixBet") }}>
                    <div>8 - K</div>
                    {Boolean(props.lastSixBet) && <div className="ABT_NT_first_last_bet_chips"><BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.lastSixBet} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip></div>}
                </div>
            </div>
        </div>
        {isDealt && <div id="ABC_cardsCointainer" className={isDealt ? "animateShowAB_Bets" : "hideAnimateShowAB_Bets"} onAnimationEnd={(e) => { !jokerCard && e.target === e.currentTarget && setJokerCardFn(props.gameResult?.joker) }}>
            <div className={`cardsCointainer ${showAB_Bets ? "moveTheElements" : ""} ${(props.showWinAnimation && props.winResult?.AB_Win === 0) ? "winAnimation" : ""}`} id="andarCardContainer" onClick={() => { props.placeBet("andar") }}>
                {andarCards.length > 0 && andarCards.map((ele, idx) => <CardCSS cardTitle={ele} newClassName="andarCard ABC_NT_CARDS" onAnimationEnd={() => {
                    // only trigger on last added card
                    if (idx === andarCards.length - 1) {
                        dealNextBaharCard();
                    }
                }}></CardCSS>)}
                <p className="ABC_NT_AB_placeHolderText">Andar</p>
                <div className={`ABC_NT_cardText ${(props.showWinAnimation && props.winResult?.AB_Win === 0) ? "winAnimation" : ""}`}>
                    <p className="ABC_NT_bet_text">Andar</p>
                    {props.andarBet !== 0 && <div className="ABC_NT_AB_betChips">
                        <BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.andarBet} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip>
                    </div>}
                </div>
            </div>
            <div className="cardsCointainer" id="jokerCardContainer">
                {jokerCard && <CardCSS cardTitle={jokerCard} newClassName="jokerCard" onAnimationEnd={() => {
                    setSafeTimeout(() => {
                        setShowAB_Bets(true)
                        props.setWinGlow()
                    }, 1000)
                }}></CardCSS>}
            </div>
            <div className={`cardsCointainer ${showAB_Bets ? "moveTheElements" : ""} ${(props.showWinAnimation && props.winResult?.AB_Win === 1) ? "winAnimation" : ""}`} id="baharCardContainer" onClick={() => { props.placeBet("bahar") }}>
                {baharCards.length > 0 && baharCards.map((ele, idx) => <CardCSS cardTitle={ele} newClassName="baharCard ABC_NT_CARDS" onAnimationEnd={() => {
                    if (idx === baharCards.length - 1) {
                        currentIndex.current++;
                        dealNextAndarCard();
                    }
                }}></CardCSS>)}
                <p className="ABC_NT_AB_placeHolderText">Bahar</p>
                <div className={`ABC_NT_cardText${(props.showWinAnimation && props.winResult?.AB_Win === 1) ? " winAnimation" : ""}`}>
                    <p className="ABC_NT_bet_text">Bahar</p>
                    {props.baharBet !== 0 && <div className={`ABC_NT_AB_betChips`}>
                        <BetPlacedChip minFontSize={80} chipWidth="100%" chipHeight="100%" betAmount={props.baharBet} chipString={props.abt_chipValues} gameId={props.gameId}></BetPlacedChip>
                    </div>}
                </div>
            </div>
        </div>}
    </>
    )
})

export default AndarBaharCardContainer